import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import './Accordion-Without-Icon-Preview.scss';
import Typography from '@material-ui/core/Typography';

const AccordionWithoutIconPreview = (props) => {
  const { config } = props;
  const [expanded, setExpanded] = useState(false);

  const handleChange = (slideNumber) => (event, isExpanded) => {
    setExpanded(isExpanded ? slideNumber : false);
  };

  return (
    <div className='accordion-no-icon mt-2 mb-2'>
      {config?.accordions?.map((accordion, accordionIndex) => (
        <Accordion
          expanded={expanded === accordionIndex}
          onChange={handleChange(accordionIndex)}
          key={accordionIndex}
        >
          <AccordionSummary
            expandIcon={expanded === accordionIndex ? <RemoveIcon /> : <AddIcon />}
            aria-controls='panel1a-content'
            id={accordionIndex}
          >
            <Typography style={{ fontSize: '12px' }}>{accordion.titleH3 || 'H3 Title'}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <p className='preview-breaks-accordian'>
              <Typography style={{ fontSize: '10px' }}>{accordion.body || 'Body'}</Typography>
            </p>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default AccordionWithoutIconPreview;
